import { ConfirmationModalTokenComponent } from './modal-confirmacion-token.component';
import { SharedModule } from './../../shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


@NgModule({
    declarations: [ConfirmationModalTokenComponent],
    imports: [
        SharedModule,
        CommonModule,
    ], exports: [ConfirmationModalTokenComponent]
})
export class SeguridadModule { }
